import styled, { css } from 'styled-components'
import { Button } from '@sainsburys-tech/bolt'
import { colorToLunaToken, hexWithTransparency } from '../../../helpers/theming/utilities'

const primaryCSS = (color: string | number, backgroundColor: string | number) => css`
  color: ${color};
  background-color: ${backgroundColor};
`

const secondaryCSS = (color: string | number) => css`
  color: ${color};
  border-color: ${color};
`

const StyledButton = styled(Button)`
  text-decoration: none;

  ${(props) => css`
    ${props.signpostLength === 1 &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        max-width: 250px;
      }
    `}
    ${props.mobileColumns &&
    css`
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        align-items: center;
        display: flex;
        justify-content: center;
        height: 100%;
      }
    `}
  `}

  flex: 1 1 auto;
  ${(props) =>
    css`
      ${secondaryCSS(colorToLunaToken(props.buttonTextColor || props.backgroundColor, props.theme))};

      ${props.theme.channel === 'tu' &&
      css`
        border-radius: 0;
      `}

      &:hover,
      &:active {
        ${props.theme.channel === 'habitat'
          ? css`
              ${secondaryCSS(
                colorToLunaToken(props.buttonTextColor, props.theme) || props.theme.color.monochrome.dark
              )};
              background-color: ${hexWithTransparency(props.theme.color.monochrome.dark, 0.06)};
            `
          : css`
              ${secondaryCSS(colorToLunaToken(props.buttonTextColor || props.backgroundColor, props.theme))};
            `}
      }
    `}

  ${(props) =>
    props.kind === 'primary' &&
    css`
      ${primaryCSS(
        colorToLunaToken(props.buttonTextColor, props.theme) || props.theme.color.monochrome.white,
        colorToLunaToken(props.backgroundColor, props.theme)
      )}

      &:hover,
        &:active {
        ${props.theme.channel === 'habitat'
          ? css`
              ${primaryCSS(
                colorToLunaToken(props.buttonTextColor, props.theme) || props.theme.color.monochrome.lighter,
                props.theme.color.monochrome.dark
              )}
            `
          : css`
              ${primaryCSS(props.theme.color.monochrome.white, colorToLunaToken(props.backgroundColor, props.theme))}
            `}
      }
    `}
`

export { StyledButton }
